/* tslint:disable */
/* eslint-disable */
/**
 * Store
 * 店舗向けAPI
 *
 * The version of the OpenAPI document: 1.0
 * Contact: kiuchi@wcdi.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { Favorite } from './Favorite';
import {
    FavoriteFromJSON,
    FavoriteFromJSONTyped,
    FavoriteToJSON,
} from './Favorite';

/**
 * 
 * @export
 * @interface AddFavorite201ResponseAllOfData
 */
export interface AddFavorite201ResponseAllOfData {
    /**
     * 
     * @type {Favorite}
     * @memberof AddFavorite201ResponseAllOfData
     */
    favorite: Favorite;
}

/**
 * Check if a given object implements the AddFavorite201ResponseAllOfData interface.
 */
export function instanceOfAddFavorite201ResponseAllOfData(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "favorite" in value;

    return isInstance;
}

export function AddFavorite201ResponseAllOfDataFromJSON(json: any): AddFavorite201ResponseAllOfData {
    return AddFavorite201ResponseAllOfDataFromJSONTyped(json, false);
}

export function AddFavorite201ResponseAllOfDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): AddFavorite201ResponseAllOfData {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'favorite': FavoriteFromJSON(json['favorite']),
    };
}

export function AddFavorite201ResponseAllOfDataToJSON(value?: AddFavorite201ResponseAllOfData | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'favorite': FavoriteToJSON(value.favorite),
    };
}

